import { useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { NAV_LINKS, LOGO_URL, PROPERTY } from "@/lib/constants";
import BookButton from "@/components/BookButton";

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();
  const isHome = pathname === "/";

  return (
    <header
      className="fixed top-0 left-0 right-0 z-50 bg-canvas/85 backdrop-blur-md border-b border-rule-subtle"
      data-testid="site-navbar"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 h-[72px] flex items-center justify-between gap-6">
        <Link to="/" className="flex items-center gap-3" data-testid="nav-logo-link" aria-label="Westbridge Inn & Suites — home">
          <img src={LOGO_URL} alt="Westbridge Inn & Suites logo" className="w-10 h-10 object-cover rounded-sm" />
          <div className="hidden sm:block leading-tight">
            <p className="font-display text-xl text-ink">Westbridge</p>
            <p className="font-mono-label text-ink-muted -mt-0.5">Inn &amp; Suites</p>
          </div>
        </Link>

        <nav className="hidden lg:flex items-center gap-8" aria-label="Primary">
          {NAV_LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-link-${l.to.replace("/", "") || "home"}`}
              className={({ isActive }) =>
                `font-mono-label transition-colors ${isActive ? "text-ember" : "text-ink-soft hover:text-ink"}`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-4">
          <a
            href={`tel:${PROPERTY.phone.replace(/[^\d+]/g, "")}`}
            className="font-display text-lg text-ink hover:text-ember transition-colors whitespace-nowrap"
            data-testid="nav-phone-link"
          >
            {PROPERTY.phone}
          </a>
          <BookButton label="Reserve" testid="nav-book-btn" />
        </div>

        <button
          className="lg:hidden inline-flex items-center justify-center w-11 h-11 border border-ink"
          aria-label={open ? "Close menu" : "Open menu"}
          aria-expanded={open}
          onClick={() => setOpen((o) => !o)}
          data-testid="nav-mobile-toggle"
        >
          <span className="sr-only">Toggle navigation</span>
          <svg width="20" height="20" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2" fill="none">
            {open ? (
              <path d="M6 6l12 12M18 6L6 18" strokeLinecap="round" />
            ) : (
              <path d="M4 7h16M4 12h16M4 17h16" strokeLinecap="round" />
            )}
          </svg>
        </button>
      </div>

      {open && (
        <div className="lg:hidden border-t border-rule-subtle bg-canvas" data-testid="nav-mobile-panel">
          <div className="px-6 py-6 flex flex-col gap-4">
            {NAV_LINKS.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                onClick={() => setOpen(false)}
                data-testid={`nav-mobile-link-${l.to.replace("/", "") || "home"}`}
                className={({ isActive }) =>
                  `font-display text-2xl ${isActive ? "text-ember" : "text-ink"}`
                }
              >
                {l.label}
              </NavLink>
            ))}
            <div className="pt-4 border-t border-rule-subtle">
              <BookButton label="Reserve a Room" testid="nav-mobile-book-btn" />
            </div>
          </div>
        </div>
      )}
      {/* spacing helper handled by main layout padding */}
      {isHome && null}
    </header>
  );
}
